<template>
  <div class="certification-manage app-panel blank-h blank-v">
    <div class="app-search-controls">
      <div class="wrap">
        <p>签约项目</p>
        <el-select v-model="search.project" placeholder="请选择签约项目">
          <el-option v-for="(value, index) in projectOptions" :key="index" :label="value.project_attr_name" :value="value.project_id"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>客户信息</p>
        <el-input placeholder="请输入客户姓名或手机号" v-model="search.value"></el-input>
      </div>
      <div class="wrap">
        <p>认证时间</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.period" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
    </div>
    <div class="app-control app-table-control">
      <el-button type="primary" @click="searchParams">搜索</el-button>
      <el-button @click="resetParams">重置</el-button>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="签约项目" prop="project_attr_name"></el-table-column>
      <el-table-column label="客户姓名" prop="contract_customer_identity_name"></el-table-column>
      <el-table-column label="抓拍照片">
        <template slot-scope="{row}">
          <el-image :src="row.contract_attachment_data.attachment_access_url" :preview-src-list="[row.contract_attachment_data.attachment_access_url]"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="手机号码" prop="contract_customer_phone"></el-table-column>
      <el-table-column label="证件号码" prop="contract_customer_identity_num"></el-table-column>
      <el-table-column label="认证方式" prop="type"></el-table-column>
      <el-table-column label="置业顾问" prop="contract_user_attr.user_attr_name"></el-table-column>
      <el-table-column label="认证时间" prop="contract_date"></el-table-column>
      <!-- <el-table-column label="认证方式" prop="type"></el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="info(row.contract_id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    <el-drawer :title="dialog.title" :visible.sync="dialog.show" center append-to-body>
      <certification-info :id="dialog.id" v-if="dialog.show"></certification-info>
    </el-drawer>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import CertificationService from '@/io/certification.js';
  import CertificationInfo from '@/views/CertificationInfo.vue';

  export default {
    name: 'CertificationManage',
    data() {
      return {
        search: {
          project: '',
          value: '',
          period: []
        },
        projectOptions: [],
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        dialog: {
          title: '认证详情',
          show: false,
          id: null
        }
      }
    },
    components: {
      CertificationInfo,
    },
    mounted() {
      this.initOptions().then(() => {
        this.initDatas();
      }).catch(() => {});
    },
    methods: {
      initOptions() {
        return ProjectService.project().then(res => {
          this.projectOptions = res.data;
        }).catch(() => {});
      },
      initDatas() {
        this.loading = true;
        CertificationService.listPage(
          this.search.project,
          this.search.value,
          this.search.period ? this.search.period[0] : '',
          this.search.period ? this.search.period[1] : '',
          this.page.currentPage
        ).then(res => {
          this.datas = res.data.data.map(val => {
            val.type = val.contract_type === 1 ? '一体机' : '小程序';
            return val;
          });
          this.page.pageSize = res.data.per_page;
          this.page.total = res.data.total;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.project = '';
        this.search.value = '';
        this.search.period = [];
        this.searchParams();
      },
      info(id) {
        this.dialog.show = true;
        this.dialog.id = id;
      }
    },
  }
</script>

<style lang="less" scoped>
  .certification-manage {
    &.blank-v {
      padding-bottom: 0;
    }
  }
</style>